var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background"},[_c('div',{staticClass:"opac"},[_c('v-container',{staticClass:"pa-0 ma-o",attrs:{"fluid":""}},[_c('v-scroll-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }